import { render, staticRenderFns } from "./TransferAgencySelectionStep.vue?vue&type=template&id=8fecf550&scoped=true&"
import script from "./TransferAgencySelectionStep.vue?vue&type=script&lang=ts&"
export * from "./TransferAgencySelectionStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fecf550",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
